export enum AnalyticsEventName {
    LOGIN_LAND = 'LOGIN_LAND',
    LOGIN_CLICKED = 'LOGIN_CLICKED',
    LOGIN_RESULT = 'LOGIN_RESULT',
    LOGIN_ATTEMPTED = 'LOGIN_ATTEMPTED',
    LOGIN_CANCELED = 'LOGIN_CANCELED',
    WEBVIEW_LAND = 'WEBVIEW_LAND',
    SHOP_LAND = 'SHOP_LAND',
    PROFILE_MENU_CLICKED = 'PROFILE_MENU_CLICKED',
    LOGOUT = 'LOGOUT',
    ERROR = 'ERROR',
    OFFER_CLICKED = 'OFFER_CLICKED',
    ORDER_RESOLVED = 'ORDER_RESOLVED',
    SUPPORT_FORM_OPEN = 'SUPPORT_FORM_OPEN',
    SUPPORT_FORM_SUBMIT = 'SUPPORT_FORM_SUBMIT',
    SUPPORT_FORM_CANCEL = 'SUPPORT_FORM_CANCEL',
    ERROR_POPUP_PRESENTED = 'ERROR_POPUP_PRESENTED',
    LANGUAGE_SELECTED = 'LANGUAGE_SELECTED',
    OFFERS_LOADED = 'OFFERS_LOADED',
    OFFERS_SHOWN = 'OFFERS_SHOWN',
    OFFERS_IMAGES_LOADED = 'OFFERS_IMAGES_LOADED',
    OFFERS_IMAGE_FAILED_LOADING = 'OFFERS_IMAGE_FAILED_LOADING',
    POP_UP_CLOSED = 'POP_UP_CLOSED',
    COLLECT_CLICKED = 'COLLECT_CLICKED',
    COLLECT_RESOLVED = 'COLLECT_RESOLVED',
    COLLECT_API_SENT = 'COLLECT_API_SENT',
    COLLECT_API_FAILED = 'COLLECT_API_FAILED',
    COMPLETE_SCREEN_PRESENTED = 'COMPLETE_SCREEN_PRESENTED',
    COMPLETE_SCREEN_BACK_TO_GAME = 'COMPLETE_SCREEN_BACK_TO_GAME',
    COMPLETE_SCREEN_BACK_TO_SHOP = 'COMPLETE_SCREEN_BACK_TO_SHOP',
    HOME_SCREEN_BUTTON_CLICK = 'HOME_SCREEN_BUTTON_CLICK',
    PROMOTION_CLICKED = 'PROMOTION_CLICKED',
    STANDALONE_MODE_ENTERED = 'STANDALONE_MODE_ENTERED',
    CHECKOUT_OPENED = 'CHECKOUT_OPENED',
    TOOLTIP_OPEN = 'TOOLTIP_OPEN',
    OUTDATED_OFFER_FAILURE = 'OUTDATED_OFFER_FAILURE',
    DEEPLINK_ACCOUNT_APPROVAL_DISPLAYED = 'DEEPLINK_ACCOUNT_APPROVAL_DISPLAYED',
    DEEPLINK_ACCOUNT_APPROVAL_APPROVE = 'DEEPLINK_ACCOUNT_APPROVAL_APPROVE',
    SSE_CONNECTION_ATTEMPT = 'SSE_CONNECTION_ATTEMPT',
    SSE_CONNECTION_ESTABLISHED = 'SSE_CONNECTION_ESTABLISHED',
    SSE_MESSAGE_RECEIVED = 'SSE_MESSAGE_RECEIVED',
    SSE_UNKNOWN_MESSAGE = 'SSE_UNKNOWN_MESSAGE',
    SSE_CONNECTION_ERROR = 'SSE_CONNECTION_ERROR',
    SSE_MAX_RETRIES_REACHED = 'SSE_MAX_RETRIES_REACHED',
    SSE_POLLING_STARTED = 'SSE_POLLING_STARTED',
}